import { ajaxController } from "./controller/AjaxController";
import { PagedResult } from "../DTOs/Common/PagedResult";
import {
  DrillBitSizeDTO,
  DrillBlastLookupDTO,
  SaveBitSizeRequest,
  SaveBlastTypeRequest,
  SaveHoleTypeRequest,
  SaveRemovalReasonRequest
} from "../DTOs/DrillBlast/DrillBlastLookupDTO";

class DrillBlastReferenceAjax {
  private _ajaxController = ajaxController;
  private _endpoint = "/DrillBlastReference";

  public getBitSizes(includeInactive = false) {
    return this._ajaxController.get<PagedResult<DrillBitSizeDTO>>(`${this._endpoint}/bit-sizes`, { includeInactive });
  }

  public getHoleTypes(includeInactive = false) {
    return this._ajaxController.get<PagedResult<DrillBlastLookupDTO>>(`${this._endpoint}/hole-types`, { includeInactive });
  }

  public getBlastTypes(includeInactive = false) {
    return this._ajaxController.get<PagedResult<DrillBlastLookupDTO>>(`${this._endpoint}/blast-types`, { includeInactive });
  }

  public getGeoDrillingTypes(includeInactive = false) {
    return this._ajaxController.get<PagedResult<DrillBlastLookupDTO>>(`${this._endpoint}/geo-drilling-types`, { includeInactive });
  }

  public getRemovalReasons(includeInactive = false) {
    return this._ajaxController.get<PagedResult<DrillBlastLookupDTO>>(`${this._endpoint}/removal-reasons`, { includeInactive });
  }

  public getConsumableTypes(includeInactive = false) {
    return this._ajaxController.get<PagedResult<DrillBlastLookupDTO>>(`${this._endpoint}/consumable-types`, { includeInactive });
  }

  public getCanEdit() {
    return this._ajaxController.get<boolean>(`${this._endpoint}/can-edit`, {});
  }

  public saveBitSize(id: number | null, request: SaveBitSizeRequest) {
    return id == null
      ? this._ajaxController.post<SaveBitSizeRequest, DrillBitSizeDTO>(`${this._endpoint}/bit-sizes`, request)
      : this._ajaxController.put<SaveBitSizeRequest, DrillBitSizeDTO>(`${this._endpoint}/bit-sizes/${id}`, request);
  }

  public saveHoleType(id: number | null, request: SaveHoleTypeRequest) {
    return id == null
      ? this._ajaxController.post<SaveHoleTypeRequest, DrillBlastLookupDTO>(`${this._endpoint}/hole-types`, request)
      : this._ajaxController.put<SaveHoleTypeRequest, DrillBlastLookupDTO>(`${this._endpoint}/hole-types/${id}`, request);
  }

  public saveBlastType(id: number | null, request: SaveBlastTypeRequest) {
    return id == null
      ? this._ajaxController.post<SaveBlastTypeRequest, DrillBlastLookupDTO>(`${this._endpoint}/blast-types`, request)
      : this._ajaxController.put<SaveBlastTypeRequest, DrillBlastLookupDTO>(`${this._endpoint}/blast-types/${id}`, request);
  }

  public saveRemovalReason(id: number | null, request: SaveRemovalReasonRequest) {
    return id == null
      ? this._ajaxController.post<SaveRemovalReasonRequest, DrillBlastLookupDTO>(`${this._endpoint}/removal-reasons`, request)
      : this._ajaxController.put<SaveRemovalReasonRequest, DrillBlastLookupDTO>(`${this._endpoint}/removal-reasons/${id}`, request);
  }
}

export const drillBlastReferenceAjax = new DrillBlastReferenceAjax();
